import styled from "@emotion/styled";
import theme from "@utils/theme";

export const Wrapper = styled.div<{ $disabled?: boolean }>`
  position: relative;
  width: 100%;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.7rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
`;

export const ItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  flex: 1;
  font-size: 14px;
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  background: ${(props: any) => props.theme.colors.primary};
  color: ${(props: any) => props.theme.colors.white};
  border-radius: 4px;
  font-size: 0.875rem;
`;

export const Remove = styled.span`
  display: flex;
  cursor: pointer;
  color: ${(props: any) => props.theme.colors.white};
`;

export const Placeholder = styled.span`
  color: #999;
  font-size: 12px;
`;

export const Dropdown = styled.div`
  position: absolute;
  width: 100%;
  max-height: 300px;
  margin-top: 0.5rem;
  background: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 10;
`;

export const Search = styled.input`
  width: 100%;
  padding: 0.5rem;
  outline: none;
`;

export const List = styled.div`
  overflow-y: auto;
  max-height: 250px;
`;

export const Item = styled.div<{ $selected?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  background: ${({ $selected }) =>
    $selected ? theme.colors.primary : "transparent"};
  color: ${({ $selected }) => ($selected ? "white" : "black")};
  cursor: pointer;

  &:hover {
    background: ${(props: any) => props.theme.colors.primary};
    color: ${(props: any) => props.theme.colors.white};
  }
`;
